<template>
  <div class="recharge-list">
    <div class="recharge-list-top">
      <div class="top-l">
        <el-select filterable v-model="customersId" clearable placeholder="请选择客户">
          <el-option
            v-for="item in customersList"
            :key="item.id"
            :label="item.nickname"
            :value="item.id">
          </el-option>
        </el-select>
        <el-date-picker
        v-model="start_date"
        :picker-options="pickerOptions2"
        type="date"
        placeholder="年/月/日">
        </el-date-picker>
        <span class="text">至</span>
        <el-date-picker
        v-model="end_date"
        :picker-options="pickerOptions1"
        type="date"
        placeholder="年/月/日">
        </el-date-picker>
        <el-button class="top-l-search" @click="searchClick()">查询</el-button>
        <el-button class="top-l-search exportbutton" :disabled="exportPrivilege==1" :class="[exportPrivilege==1?'active':'']" @click="exportClick()">导出</el-button>
        <div style="clear:both;"></div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="recharge-list-bottom">
      <div class="recharge-list-table">
        <el-table
        :data="yemiandata"
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        border
        style="width: 100%">
            <el-table-column
            prop="nickname"
            label="集团名称"
            width="150">
            </el-table-column>
            <el-table-column
            prop="username"
            label="集团ID"
            width="150">
            </el-table-column>
            <el-table-column
            prop="type"
            label="充值方式"
            width="130">
            </el-table-column>
            <el-table-column
            prop="order_sn"
            label="订单号"
            width="">
            </el-table-column>
            <el-table-column
            prop="operate_user"
            label="操作用户"
            width="">
            </el-table-column>
            <el-table-column
            prop="fee"
            label="充值金额"
            width="">
            </el-table-column>
            <el-table-column
            prop="amount_voucher"
            label="赠送抵扣券"
            width="">
            </el-table-column>
            <el-table-column
            prop="pay_time"
            label="充值时间"
            width="160">
              <template slot-scope="scope">{{ scope.row.pay_time | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="remarks"
            label="备注"
            width="">
            </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDateFilter } from "@/filters";
import API_ROOT from "../../../config/dev.env"
export default {
  data() {
    return {
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      value: "",
      options:[],
      start_date:"",
      end_date:"",
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < this.start_date || time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        }
      },
      customersList:[],
      customersId:"",
      exportPrivilege:1,//导出
      linkurl:"",
      baseUrl:"https://service-web.szdreamerstech.com//api.php/index/recharge_export?uid=",
      baseurl2:"",
    };
  },
  mounted() {
    this.$nextTick(function() {
      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "会员管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "集团客户"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "导出充值记录"){
                  this.exportPrivilege = 0;
                }
              }
            }
          }
        }
      }

      this.getCustomers();
      this.getDataList();
    });
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(id,start_date,end_date){
      if(id == undefined){
        id = "";
      }
      if(start_date == undefined){
        start_date = "";
      }
      if(end_date == undefined){
        end_date = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getRechargeLogs",
        id:id,
        start_date:start_date ? parseDateFilter(start_date, 'yyyy-MM-dd') : '',
        end_date:end_date ? parseDateFilter(end_date, 'yyyy-MM-dd') : '',
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if(this.totalNum > 10){
              // debugger
              this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    getCustomers(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getCustomers",
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.customersList = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.customersId,this.start_date,this.end_date);
    },
    /**
     * 导出数据csv
     */
    exportClick(){
      // let name = "";
      // if(this.customersId !=""){
      //   for(let i in this.customersList){
      //     if(this.customersList[i].id == this.customersId){
      //       name = this.customersList[i].nickname;
      //     }
      //   }
      // }else {
      //   name = "";
      // }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"exportRecharge",
        id:this.customersId,
        start_date:this.start_date ? parseDateFilter(this.start_date, 'yyyy-MM-dd') : '',
        end_date:this.end_date ? parseDateFilter(this.end_date, 'yyyy-MM-dd') : '',
      };

      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.linkurl = su.data.url;
            this.createAndDownloadFile(su.data.url);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 302) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 303) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            this.$message.warning(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    /**
     * 导出调用方法
     */
    createAndDownloadFile(content) {
       let link = document.createElement("a");
      let contentArr = content.split("/");
      contentArr[0] = JSON.parse(API_ROOT.API_ROOT);
      content = contentArr[0] + "/" + contentArr[1] +  "/" + contentArr[2] + "/" + contentArr[3];

      link.href = content;
      link.click();
    },
  }
};
</script>

<style scoped lang="scss">
.recharge-list {
  padding:20px 0;
  .recharge-list-top {
    .top-l {
      float: left;
      margin-left: 1%;
      .el-select {
        width: 20%;
        float: left;
        margin-right: 10px;
      }
      .el-input {
        width: 20%;
        float: left;
        margin-right: 10px;
      }
      .top-l-search {
        background-color: #0071bd;
        border: none;
        color: #fefffd;
        float: left;
      }
      .top-l-search:active {
        background-color: #409EFF;
      }
      .exportbutton {
        background-color: #00b270;
        border: none;
        color: #fff;
        float: left;
        span {
          display:inline-block;
          width:100%;
          height:100%;
          a {
            color:#fff;
            text-decoration:none;
            display:inline-block;
            width:100%;
            height:100%;
         }
        }
      }
      .exportbutton.active {
        background-color: #a5a5a5;
      }
      .exportbutton.active:hover {
        background-color: #a5a5a5;
      }
      .text {
        float: left;
        // margin: 4px;
        margin-top: 8px;
        margin-right: 10px;
      }
    }
  }
  .recharge-list-bottom {
    .recharge-list-table {
        width: 98%;
        margin-left: 1%;
        margin-top: 26px;
        margin-bottom: 10px;
        .table-btn {
            width: 54px;
            height: 30px;
            padding: 0;
            background-color: #006fbe;
            border:none;
            color: #fefffd;
            margin-left: 5px;
        }
        .table-vehicle {
            background-color: #00b270;
        }
        .table-dis {
            background-color: #eb0000;
        }
        .table-recharge {
            background-color: #ec6900;
        }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/rechargeRecord.vue